import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { PageBody } from '../../../elements/page-body';
import { Button } from '../../../elements/button';
import { Map } from '../../../elements/map';
import { formatDateTime } from '../../../utils';


const initialValues = {
    date: '',
};




export const JobsOptimization = () => {
    const { t } = useTranslation() as { t: (key: string) => string };
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [showSteps, setShowSteps] = useState<any>({});

    const onSubmit = (values: any) => {
        api(`/fleet/optimize/`, 'GET');
        //api(`/fleet/drivers/1/trips/?date=2025-08-02`, 'GET');
    };

    const handleShow = (index: number) => {
        setShowSteps((prev: any) => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('optimize')) {
                if (state.method === 'POST' || state.method === 'PATCH') {
                } else {
                    console.log('state.data', state.data)
                    setData(state.data.result)
                }
            }
        }

        if (state.error) {

        }
    }, [state]);

    return (
        <PageBody
            title={'dashboard.label.optimizacion-encargos'}
        >
            <>
                <div className="relative z-10">
                    <Formik
                        initialValues={initialValues}
                        onSubmit={onSubmit}
                        enableReinitialize
                    >
                        {({ values, errors, touched, setFieldValue, handleSubmit }) => (
                            <form onSubmit={handleSubmit} autoComplete="off">
                                <div className="pt-4">
                                    <div className="flex justify-between">
                                        <div className="">
                                            <Button
                                                label={t('common.label.calcular-opt-encargo')}
                                                onClick={handleSubmit}
                                                disabled={state.loading}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Formik>
                </div>
                <div className="py-4 bg-gray-100 rounded-md my-4">
                    {data && (
                        <>
                            <div className='w-full border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm rounded-md'>
                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.numero-rutas')}:</span> {data?.routes.length}</div>
                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-total-viaje')}:</span> {data?.summary.duration_display}</div>
                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-total-setup')}:</span> {data?.summary.setup_display}</div>
                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-total-servicio')}:</span> {data?.summary.service_display}</div>
                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.tiempo-total-espera')}:</span> {data?.summary.waiting_time_display}</div>
                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.encargos-transportes-no-asignados')}:</span> {data?.summary.unassigned}</div>
                            </div>
                            {data.routes.length > 0 ?
                                <div className='pt-4'>
                                    <div className='text-[14px] font-semibold'>{t('common.label.rutas')}</div>
                                    {data.routes.map((item: any, index: number) => {
                                        return <div className='w-full border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm rounded-md'>
                                            <div className='w-full flex'>
                                                <div className='w-1/3'>
                                                    <div className='h-24'>
                                                        {item?.vehicle?.photo_display_url ? <img className='h-[120px] pb-4' src={item?.vehicle?.photo_display_url} /> : <div className='w-[180px] h-[120px] bg-gray-300 flex items-center justify-center'><span className='text-gray-500 text-sm'>{t('common.form-label.image-vehicle')}</span></div>}
                                                    </div>
                                                    <div className='mt-8'>
                                                        <Button
                                                            onClick={() => handleShow(index)}
                                                            label={t('common.label.mostrar-pasos')}
                                                        />
                                                    </div>

                                                </div>
                                                <div className='w-2/3'>
                                                    <div className='text-[13px] pb-4'><span className='font-semibold'>{t('common.form-label.matricula')}:</span> {item.vehicle.plate}</div>
                                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-total-viaje')}:</span> {item.duration_display}</div>
                                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-total-setup')}:</span> {item.setup_display}</div>
                                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-total-servicio')}:</span> {item.service_display}</div>
                                                    <div className='text-[13px]'><span className='font-semibold'>{t('common.label.tiempo-total-espera')}:</span> {item.waiting_time_display}</div>
                                                </div>
                                            </div>
                                            {showSteps[index] ?
                                                <div className='pt-2'>
                                                    {data.routes[index].steps.map((item: any, index: number) => {
                                                        return <div className='w-full flex border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm rounded-md mb-2'>
                                                            <div className='w-2/3 h-48'>
                                                                <Map longitude={item.location[0]} latitude={item.location[1]} />
                                                            </div>
                                                            <div className='w-1/3 pl-8'>
                                                                {item.type == 'start' ? <div className='text-[13px]'><span className='font-semibold'>{t('common.form-label.salida')}:</span> {formatDateTime(item.arrival_display)}</div> : <div className='text-[13px]'><span className='font-semibold'>{t('common.form-label.llegada')}:</span> {formatDateTime(item.arrival_display)}</div>}

                                                                <div className='text-[13px]'><span className='font-semibold'>{t('common.form-label.tipo')}:</span> {item.type}</div>
                                                                <div className='text-[13px]'><span className='font-semibold'>{t('common.form-label.descripcion')}:</span> {item.description}</div>
                                                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-total-viaje')}:</span> {item.duration_display}</div>
                                                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-total-setup')}:</span> {item.setup_display}</div>
                                                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.duracion-total-servicio')}:</span> {item.service_display}</div>
                                                                <div className='text-[13px]'><span className='font-semibold'>{t('common.label.tiempo-total-espera')}:</span> {item.waiting_time_display}</div>
                                                            </div>
                                                        </div>
                                                    })}
                                                </div>
                                                : ''}

                                        </div>
                                    })}
                                </div>
                                : ''}
                        </>

                    )}
                </div>
            </>
        </PageBody>
    );
};